import pug from "refractor/pug";
export default pug;